import { useEffect, useState } from 'react';
import { useClient } from '../../../context/ClientContext';
import configA from '../../../clients/HelloHealth/stepsConfig';
import configB from '../../../clients/clientB/stepsConfig';
import ClientQuestionBase from '../common/ClientQuestionBase';
import healthSymptomCheckerConfig from '../../../clients/HelloHealth/helloHealthSymptomCheckerConfig';


export default function MasterSymptomCheckerPage() {
  const { clientId } = useClient();
  const { theme } = useClient();
  const steps = clientId === 'hellohealth' ? healthSymptomCheckerConfig : configB;
  const [stepIndex, setStepIndex] = useState(0);
  const [userData, setUserData] = useState({});

  const CurrentStep = steps[stepIndex];
  const resultsToken = new URLSearchParams(location.search).get('result');

  useEffect(() => {
    // localStorage.setItem('organization_id', '2');
    localStorage.setItem('organization_id', theme.orgId);
    if (resultsToken) {
      localStorage.setItem('results_token', resultsToken);
    }
  }, [resultsToken]);

  return (
    <ClientQuestionBase
      IsShowBackIcon={stepIndex > 0}
      backButtonHandler={() => setStepIndex((prev) => Math.max(prev - 1, 0))}
      aimdLinearBarValue={((stepIndex + 1) / steps.length) * 100}
    >
      <CurrentStep
        userData={userData}
        setUserData={setUserData}
        onNext={() => setStepIndex((prev) => prev + 1)}
        onBack={() => setStepIndex((prev) => Math.max(prev - 1, 0))}
      />
    </ClientQuestionBase>
  );
}
